

export enum SessionGroupCoupleRole {
  A = 'A',
  B = 'B',
};
